import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M69.21 41.207c.811-12.694 1.217-21.381.125-34.586-.238-2.878-2.546-5.139-5.425-5.361C42.25-.415 28.084-.423 6.083 1.253a5.929 5.929 0 0 0-5.47 5.53C-.196 19.472-.211 28.36.613 41.26a5.927 5.927 0 0 0 5.478 5.526c21.881 1.63 36.024 1.606 57.612.002a5.974 5.974 0 0 0 5.508-5.58z",
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M65.329 38.824c.683-10.89 1.015-18.531.118-29.858-.228-2.879-2.54-5.147-5.418-5.369-18.616-1.437-31.01-1.444-49.912-.006a5.921 5.921 0 0 0-5.464 5.53c-.671 10.887-.684 18.69-.002 29.753a5.92 5.92 0 0 0 5.473 5.53c18.791 1.398 31.16 1.377 49.7.002a5.97 5.97 0 0 0 5.505-5.582z",
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M15 24.5h5.02l3.861-5.41L28.901 35l8.495-21 4.634 15.273 4.633-7.319H54",
  stroke: "#fff",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 70,
    height: 48,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/faq-ecg.3004effa.svg";
export { SvgComponent as ReactComponent };